import { useIntercom } from "@/hooks/useIntercom";
import { Badge } from "@components/ui/badge";
import { Button } from "@components/ui/button";
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { CircleSlashIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function Unavailable() {
  const intercom = useIntercom();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CircleSlashIcon />
        </EmptyMedia>
        <EmptyTitle className="flex items-center gap-2">
          <Trans>Avslutade bevaknigar</Trans>
          <Badge variant="violet">
            <Trans>Premium</Trans>
          </Badge>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>
            För att se omnämnanden i dina avslutade bevakningar behöver du
            uppgradera din plan.
          </Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="flex-row justify-center gap-2">
        {intercom.show && (
          <Button
            type="button"
            data-testid="upsale-screen-cta"
            onClick={() => {
              intercom.show();
            }}
          >
            <Trans>Boka ett möte</Trans>
          </Button>
        )}
      </EmptyContent>
      <Button
        variant="link"
        asChild
        className="text-muted-foreground"
        size="sm"
      >
        <Link
          to={{
            search: "?upsale=true",
          }}
        >
          <Trans>Utforska våra priser</Trans>
        </Link>
      </Button>
    </Empty>
  );
}
